<template>
  <v-form @submit.prevent="handleSubmitForm" class="user-form">
    <v-card>
      <input
        type="file"
        ref="file"
        @change="handleUploadImage"
        v-show="false"
        accept="image/png, image/jpeg"
      />
      <v-app-bar flat>
        <v-toolbar-title class="font-weight-medium">
          <v-icon left>mdi-shape</v-icon>
          {{getCardTitle()}}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="handleCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-img
        aspect-ratio="1"
        height="200"
        :src="image_url"
      >
        <v-row
          align="start"
          justify="end"
          class="lightbox ma-2"
          no-gutters
        >
          <v-btn @click="removeImage" color="primary" v-show="image_url" :loading="deleting_image">
            <v-icon size="24">mdi-delete</v-icon>
          </v-btn>
          <v-btn @click="openFilesDialog" color="primary" class="ml-2" :loading="uploading_image">
            <v-icon size="24">mdi-upload</v-icon>
          </v-btn>
        </v-row>
        <template v-slot:placeholder>
          <v-overlay absolute>
            <v-icon>mdi-image-off</v-icon>
          </v-overlay>
        </template>
      </v-img>
      <v-card-text>
        <ValidationObserver ref="forms" v-slot="{ invalid }">
          <ValidationProvider name="name" rules="required|max:45" v-slot="{ errors }">
            <v-text-field
              label="Nome"
              name="name"
              type="text"
              :counter="45"
              v-model="form.name"
              :error-messages="errors"
              :loading="loading"
              :disabled="loading"
            />
          </ValidationProvider>
          <ValidationProvider name="external_categories" v-slot="{ errors }">
            <category-select
              label="Categorias Externas"
              :category="form.categories"
              :loading="loading"
              :disabled="loading"
              multiple
              :error-messages="errors"
              chips
              deletable-chips
              readonly
              v-if="form.id"
            />
          </ValidationProvider>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleCancel" text :disabled="submitting">Cancelar</v-btn>
        <v-btn type="submit" color="primary" :loading="submitting">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { show, store, update, updateImage, deleteImage } from "../../services/local_categories";

import CategorySelect from "../autocompletes/CategorySelect";

export default {
  name: "local-category-form",
  components: {
    CategorySelect
  },
  model: {
    prop: "category",
    event: "change",
  },
  props: ["category"],
  data: () => ({
    form: {
      name: ''
    },
    uploaded_image: null,
    loading: false,
    submitting: false,
    uploading_image: false,
    deleting_image: false
  }),
  methods: {
    getCardTitle() {
      return this.category?.id ? this.category.name : "Novo tipo de produto";
    },
    handleCancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    resetForm() {
      this.form = {
        name: '',
        image_path: null,
        image_url: null
      };

      this.uploaded_image = null;
      this.$refs.forms.reset();
    },
    async loadCategory(category) {
      this.form = category ? category : {};

      if (category?.id) {
        this.loading = true;
        try {
          const response = await show(category?.id);
          this.form = {
            ...response
          };
        } catch(e) {
          this.$store.commit('sendMessage', {
            text: e.response.data,
            color: 'red'
          });
        } finally {
          this.loading = false;
        }
      }
    },
    async handleSubmitForm() {
      const validation = await this.$refs.forms.validate();
      if (!validation) return;

      this.submitting = true;
      try {
        let message = "Registro atualizado";
        if (this.form?.id) {
          this.form = await update(this.form?.id, this.form);
        } else {
          const form_data = new FormData();
          form_data.append('name', this.form?.name);
          form_data.append('image', this.uploaded_image);

          message = "Registro criado com sucesso";
          this.form = await store(form_data);
        }

        this.$emit("submit", this.form);
        this.resetForm();
        this.$store.commit("sendMessage", {
          text: message,
        });
      } catch (e) {
        this.$refs.forms.setErrors(e.response.data.errors);
        this.$store.commit("sendMessage", {
          text: `(${e.response.status}) ${e.response.data.message}`,
          color: "red",
        });
      } finally {
        this.submitting = false;
      }
    },
    openFilesDialog() {
      this.$refs.file.click();
    },
    async handleUploadImage($event) {
      const image = $event.target.files[0];
      this.uploaded_image = image;

      if (this.form?.id) {
        this.uploading_image = true;
        try {
          const form_data = new FormData();
          form_data.append('image', image);

          const response = await updateImage(this.form?.id, form_data);
          this.form.image_url = response.image_url;
        } catch (e) {
          this.$store.commit("sendMessage", {
            text: e.response.data.message,
            color: "red",
          });
        } finally {
          this.uploading_image = false;
        }
      }

      this.$refs.file.value = '';
    },
    async removeImage($event) {
      if (this.form?.id) {
        this.deleting_image = true;
        try {
          await deleteImage(this.form?.id);

          this.form.image_path = null;
          this.form.image_url = null;

          this.uploaded_image = null;
          this.$store.commit("sendMessage", {
            text: 'Imagem removida',
          });
        } catch (e) {
          this.$refs.forms.setErrors(e.response.data.errors);
          this.$store.commit("sendMessage", {
            text: `(${e.response.status}) ${e.response.data.message}`,
            color: "red",
          });
        } finally {
          this.deleting_image = false;
        }
      } else {
        this.uploaded_image = null;
      }
    }
  },
  computed: {
    image_url: function() {
      if (this.form.image_path)
        return this.form.image_url;

      if (this.uploaded_image)
        return URL.createObjectURL(this.uploaded_image);

      return null;
    }
  },
  created() {
    this.loadCategory(this.category);
  },
  watch: {
    category: function (value, old_value) {
      if (value == null) {
        this.resetForm();
      }

      this.loadCategory(value);
    },
  },
};
</script>
